// Privileged Supabase credentials must never be compiled into a Vite/browser bundle.
// Account provisioning belongs in a server endpoint or Supabase Edge Function.
export const supabaseAdmin = null;

export const isAdminAvailable = () => false;

export default supabaseAdmin;
